import type { IconSvgObject } from './types';

const Cone01Icon: IconSvgObject = [
  ["path", { d: "M21 17.5043C21 15.2951 16.9706 13.5043 12 13.5043C7.02944 13.5043 3 15.2951 3 17.5043C3 19.7134 7.02944 21.5043 12 21.5043C16.9706 21.5043 21 19.7134 21 17.5043Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 17.0042L12.8648 2.99361C12.4793 2.32979 11.5207 2.32979 11.1352 2.99361L3 17.0042", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Cone01Icon;
